import { useMemo } from 'react';

import { Group } from '@mantine/core';
import { IconClipboardHeart } from '@tabler/icons-react';

import useLayoutProps from '@hooks/useLayoutProps';

import TherapiesTable from '@components/therapies/TherapiesTable';

export default function TherapiesList() {
  const title = useMemo(
    () => (
      <Group>
        <IconClipboardHeart />
        Terapie
      </Group>
    ),
    [],
  );

  useLayoutProps({
    title,
  });

  return <TherapiesTable />;
}
